export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";